module.exports = __webpack_public_path__ + "img/demo-warning-arrow.473e46c9.svg";